export default {
  runes: {
    // 8100: { // Domination
    // },
    8112: {
      name: "Electrocute",
      text: "[rune_8112]'s 3 stack burst means it is often taken with [role] champions, like [champion], with quick trade combos or assassination potential.",
      score: 3,
    },
    8124: {
      name: "Predator",
      text: "[rune_8124] gives your Boots an unique MS and damage active, great if you're looking to roam on [champion] [role].",
      score: 3,
    },
    8128: {
      name: "Dark Harvest",
      text: "Take [rune_8128] on [champion] [role] to surprise low HP enemies with instant execute damage.",
      score: 2,
    },
    9923: {
      name: "Hail of Blades",
      text: "[rune_9923] lets you get off three quick auto attacks, making it a strong early game Keystone choice for [champion] [role].",
      score: 3,
    },
    8126: {
      name: "Cheap Shot",
      text: "[rune_8126] is a strong [champion2] rune because of the CC in [champion]'s kit.",
      score: 1,
    },
    8139: {
      name: "Taste of Blood",
      text: "[rune_8139] is a strong [champion2] rune because it offers valuable sustain, especially early on.",
      score: 2,
    },
    8143: {
      name: "Sudden Impact",
      text: "[rune_8143] is a strong [champion2] rune because [champion]'s built-in mobility lets them effectively use the bonus hybrid penetration.",
      score: 3,
    },
    8136: {
      name: "Zombie Ward",
      text: "[rune_8136] is a versatile rune, including on [champion], as it rewards you with stats and vision for clearing wards.",
      score: 3,
    },
    8120: {
      name: "Ghost Poro",
      text: "Take [rune_8120] on [champion] to extend the duration of your ward vision.",
      score: 2,
    },
    8138: {
      name: "Eyeball Collection",
      text: "[champion] benefits from the stacking damage stats from [rune_8138].",
      score: 1,
    },
    8135: {
      name: "Treasure Hunter",
      text: "[rune_8135] rewards an aggressive playstyle, allowing [champion] to snowball with the gold bounties.",
      score: 1,
    },
    8134: {
      name: "Ingenious Hunter",
      text: "[rune_8134] significantly reduces Active Cooldowns, like [rune_8124].",
      score: 1,
    },
    8105: {
      name: "Relentless Hunter",
      text: "[rune_8105]'s out-of-combat mobility lets you roam, rotate, and ward with tempo.",
      score: 2,
    },
    8106: {
      name: "Ultimate Hunter",
      text: "[rune_8106] lets you get more value from your strong ultimate.",
      score: 1,
    },
    // 8300: { // Inspiration
    // },
    8351: {
      name: "Glacial Augment",
      text: "The [rune_8351] Keystone provides unique utility, especially great for [champion] [role] builds including Actives with Slows.",
      score: 2,
    },
    8360: {
      name: "Unsealed Spellbook",
      text: "[rune_8360] is a versatile option for [champion] [role], who can make better use from Summoner Spells than other Keystones.",
      score: 2,
    },
    8358: {
      name: "Prototype: Omnistone",
      text: "[rune_8358] is a niche Keystone rune option for [champion] [role], one of the few champions who can effectively use it.",
      score: 3,
    },
    8369: {
      name: "First Strike",
      text: "[rune_8369]'s gold and damage amp shines in the mid and late game. However, the keystone also synergizes well with [champion]'s early game trading and skirmish patterns.",
      score: 3,
    },
    8306: {
      name: "Hextech Flashtraption",
      text: "The unexpected engage potential from [rune_8306] makes it a strong [champion2] rune, especially with [rune_8275].",
      score: 3,
    },
    8304: {
      name: "Magical Footwear",
      text: "Trade early game mobility for better free boots: [rune_8304]'s economic value makes it a strong rune on many champions, including [champion2].",
      score: 3,
    },
    // 8313: { Replaced by Triple Tonic
    //   name: "Perfect Timing",
    //   text: "[rune_8313] is a strong [champion2] rune option for tower dives and outplays, especially if you plan on building Stopwatch items later on.",
    //   score: 3,
    // },
    8313: {
      name: "Triple Tonic",
      text: "[rune_0000]'s three elixirs allow you to surprise opponents with flexible and unique power spikes.",
      score: 3,
    },
    8321: {
      name: "Future's Market",
      text: "Take [rune_8321] on [champion] to reach unique power spikes from accelerated item completion timings.",
      score: 2,
    },
    8316: {
      name: "Minion Dematerializer",
      text: "Take [rune_8316] on [champion] to improve your lane management.",
      score: 2,
    },
    8345: {
      name: "Biscuit Delivery",
      text: "Take [rune_8345] for early game sustain on [champion]. Can be sold for 30g.",
      score: 2,
    },
    8347: {
      name: "Cosmic Insight",
      text: "[rune_8347] provides unique CDR to all abilities.",
      score: 1,
    },
    8410: {
      name: "Approach Velocity",
      text: "[rune_8410] improves your chase and follow-up potential.",
      score: 2,
    },
    8352: {
      name: "Time Warp Tonic",
      text: "[rune_8352] gives an outplay edge by frontloading consumable healing and giving MS on their usage.",
      score: 3,
    },
    // 8000: { // Precision
    // },
    8005: {
      name: "Press the Attack",
      text: "[champion] takes [rune_8005] because their kit can reliably trigger the bonus damage and increased damage debuff.",
      score: 3,
    },
    8008: {
      name: "Lethal Tempo",
      text: "[rune_8008]'s delayed bonus AS synergizes well with how [champion] [role] likes to deal damage.",
      score: 3,
    },
    8021: {
      name: "Fleet Footwork",
      text: "[rune_8021] provides versatile sustain and temporary MS for [champion] in [role].",
      score: 2,
    },
    8010: {
      name: "Conqueror",
      text: "While less effective on ranged champions, [rune_8010] offers stacking damage and healing for sustained trades, which is great for [champion] [role].",
      score: 3,
    },
    9101: {
      name: "Overheal",
      text: "While [rune_9101] is a niche option, its added survivability complements high sustain itemization, making it a strong [champion2] rune.",
      score: 3,
    },
    9111: {
      name: "Triumph",
      text: "[rune_9111] provides often unexpected healing after takedowns, making it a great [champion2] rune.",
      score: 2,
    },
    8009: {
      name: "Presence of Mind",
      text: "[rune_8009] is a great [champion2] rune given the champion's mana dependency.",
      score: 2,
    },
    9104: {
      name: "Legend: Alacrity",
      text: "Given attack speed is multiplicative, Take [rune_9104] to increase the value of [champion]'s kit and build.",
      score: 3,
    },
    9105: {
      name: "Legend: Tenacity",
      text: "[rune_9105] is a viable option into high CC compositions, and on champions with built-in Tenacity.",
      score: 3,
    },
    9103: {
      name: "Legend: Bloodline",
      text: "Take [rune_9103] for additional sustain or to forgo lifesteal itemization.",
      score: 3,
    },
    8014: {
      name: "Coup de Grace",
      text: "Take [rune_8014] to improve your kill pressure on low health targets.",
      score: 1,
    },
    8017: {
      name: "Cut Down",
      text: "[rune_8017] will give you a small edge versus tanky compositions.",
      score: 1,
    },
    8299: {
      name: "Last Stand",
      text: "[rune_8299] will give you a small edge in low health situations.",
      score: 1,
    },
    // 8400: { // Resolve
    // },
    8437: {
      name: "Grasp of the Undying",
      text: "The [rune_8437] Keystone lets [champion] sustain and gain health versus other [role] champions.",
      score: 2,
    },
    8439: {
      name: "Aftershock",
      text: "The bonus resistances when CCing an enemy make [rune_8439] a strong keystone on initiators like [champion] [role].",
      score: 3,
    },
    8465: {
      name: "Guardian",
      text: "With [rune_8465] on [champion] [role], stay near your carries during laning phase and teamfights to keep them alive.",
      score: 3,
    },
    8446: {
      name: "Demolish",
      text: "[rune_8446] is a strong [champion2] rune for taking turrets.",
      score: 1,
    },
    8463: {
      name: "Font of Life",
      text: "[rune_8463] will let allies heal off [champion]'s CC, making it a viable [champion2] rune option.",
      score: 2,
    },
    8401: {
      name: "Shield Bash",
      text: "Shielding in [champion]'s kit makes the bonus damage from [rune_8401] a viable [champion2] rune option.",
      score: 2,
    },
    8429: {
      name: "Conditioning",
      text: "Take [rune_8429] to increase survivability, especially if you plan on building resistances on [champion].",
      score: 2,
    },
    8444: {
      name: "Second Wind",
      text: "[rune_8444] on [champion] works best to mitigate poke from an enemy laner.",
      score: 2,
    },
    8473: {
      name: "Bone Plating",
      text: "[rune_8473] provides the most early game survivability for [champion] against all-ins and extended trades.",
      score: 3,
    },
    8451: {
      name: "Overgrowth",
      text: "Take [rune_8451] to increase your HP as the game goes on.",
      score: 1,
    },
    8453: {
      name: "Revitalize",
      text: "Take [rune_8453] if your champion or team has heals and shields.",
      score: 1,
    },
    8242: {
      name: "Unflinching",
      text: "Take [rune_8242] to mitigate incoming slows and CC. [rune_8242] also reduces self-slows.",
      score: 2,
    },
    // 8200: { // Sorcery
    // }
    8214: {
      name: "Summon Aery",
      text: "[rune_8214] empowers spells, autos, heals, and shields, making it a versatile [role] option for [champion].",
      score: 2,
    },
    8229: {
      name: "Arcane Comet",
      text: "[rune_8229]'s damaging projectile strengthens [champion] [role]'s laning and poke potential.",
      score: 3,
    },
    8230: {
      name: "Phase Rush",
      text: "[rune_8230]'s bonus movement speed provides kiting and chase potential, great for [champion] [role].",
      score: 3,
    },
    8224: {
      name: "Nullifying Orb",
      text: "[rune_8224] is a valuable [champion2] rune into certain AP matchups, letting you mitigate burst or all-in.",
      score: 3,
    },
    8226: {
      name: "Manaflow Band",
      text: "The mana and mana regeneration makes [rune_8226] a staple [champion2] rune.",
      score: 2,
    },
    8275: {
      name: "Nimbus Cloak",
      text: "A strong [champion2] rune, [rune_8275]'s versatile MS on Summoner Spell casts improves [champion]'s chase or kiting ability.",
      score: 3,
    },
    8210: {
      name: "Transcendence",
      text: "The CDR from [rune_8210] lets [champion] reach maximum CDR or diversify their item path.",
      score: 2,
    },
    8234: {
      name: "Celerity",
      text: "Take [rune_8234] to augment [champion]'s built-in MS abilities.",
      score: 1,
    },
    8233: {
      name: "Absolute Focus",
      text: "[rune_8233]'s bonus damage stats while you are high HP lets [champion] deal more damage while healthy.",
      score: 2,
    },
    8237: {
      name: "Scorch",
      text: "Take [rune_8237] for extra early game trade damage. Be careful when poking under tower, as [rune_8237]'s DPS will draw tower aggro.",
      score: 3,
    },
    8232: {
      name: "Waterwalking",
      text: "Take [rune_8232] for an extra edge in river fights over Scuttle and other objectives.",
      score: 2,
    },
    8236: {
      name: "Gathering Storm",
      text: "Take [rune_8236] for an extra edge as the game goes on.",
      score: 1,
    },
  },
  statShards: [
    {
      // Offense
      5008: {
        // Adaptive Force
        jungle: {
          text: "Take [shard_5008] rune shard first on junglers like [champion], whose clear is not dependent on auto attacks.",
          score: 3,
        },
        lane: {
          text: "First slot [shard_5008] grants strong early damage potential and burst for [champion] [role].",
          score: 3,
        },
      },
      5005: {
        // Attack Speed
        jungle: {
          text: "[shard_5005] is the go-to second rune shard to improve clear speed.",
          score: 1,
        },
        lane: {
          text: "The early attack speed from the [shard_5005] rune shard helps with early CSing, making it great for all laners, including [champion] [role].",
          score: 3,
        },
      },
      5007: {
        // Scaling CDR
        jungle: {
          text: "The [shard_5007] rune shard works uniquely well with niche junglers like [champion], who don't need early damage or AS to be effective.",
          score: 3,
        },
        lane: {
          text: "The [shard_5007] rune shard trades early strength on [champion] [role] for later game utility.",
          score: 2,
        },
      },
    },
    {
      // Flex
      5008: {
        // Adaptive Force
        jungle: {
          text: "Taking [shard_5008] second gives extra damage for early jungle clearing and skirmishes.",
          score: 2,
        },
        lane: {
          text: "[shard_5008] is the standard second shard into most matchups.",
          score: 1,
        },
      },
      5002: {
        // Armor
        jungle: {
          text: "[shard_5002] second trades damage for unexpected survivability, vs both camps and enemies.",
          score: 2,
        },
        lane: {
          text: "Take [shard_5002] as your second shard for extra survivability or into tough AD matchups.",
          score: 2,
        },
      },
      5003: {
        // MR
        jungle: {
          text: "[shard_5003] second offers unique tankiness against AP heavy comps.",
          score: 2,
        },
        lane: {
          text: "Take [shard_5003] as your second shard for extra survivability or into tough AP matchups.",
          score: 2,
        },
      },
      5010: {
        // Move Speed
        jungle: {
          text: "[shard_5010] is a great option on low mobility champions and roamers.",
          score: 2,
        },
        lane: {
          text: "[shard_5010] is a great option on low mobility champions and roamers.",
          score: 2,
        },
      },
      5001: {
        // Scaling Bonus Health
        jungle: {
          text: "[shard_5001] second trades early survivability for mid and late game health.",
          score: 3,
        },
        lane: {
          text: "[shard_5001] second trades early survivability for mid and late game health.",
          score: 2,
        },
      },
    },
    {
      // Defense
      5001: {
        // Scaling Bonus Health
        jungle: {
          text: "[shard_5001] third trades early survivability for mid and late game health.",
          score: 3,
        },
        lane: {
          text: "[shard_5001] third trades early survivability for mid and late game health.",
          score: 2,
        },
      },
      5002: {
        // Armor
        jungle: {
          text: "[shard_5002] third is standard for junglers, as it reduces jungle monster damage.",
          score: 2,
        },
        lane: {
          text: "Take [shard_5002] third versus physical damage (AD) matchups.",
          score: 1,
        },
      },
      5003: {
        // MR
        jungle: {
          text: "[shard_5003] third trades survivability versus jungle camps for skirmish potential with AP opponents.",
          score: 2,
        },
        lane: {
          text: "Take [shard_5003] third versus magic damage (AP) matchups.",
          score: 1,
        },
      },
      5011: {
        // Flat HP
        jungle: {
          text: "[shard_5011] is a versatile option for early game survivability.",
          score: 2,
        },
        lane: {
          text: "[shard_5011] is a versatile option for early game survivability.",
          score: 1,
        },
      },
      5013: {
        // Tenacity/Resist
        jungle: {
          text: "[shard_5013] synergizes well with [champ]'s kit and itemization.",
          score: 2,
        },
        lane: {
          text: "[shard_5013] synergizes well with [champ]'s kit and itemization.",
          score: 1,
        },
      },
    },
  ],
};
